module.exports = __webpack_public_path__ + "p4_img8.jpg?87a1c99348147a3218949bbb213c6d2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img8.jpg
// module id = 115
// module chunks = 0